import { Timestamp } from "firebase/firestore";

export const VCDBUserCollection = "users";

export function mapDocToVCDBUser(id: string, data: any): VCDBUser {
  return {
    id,
    email: data.email,
    name: data.name,
    createdAt: data.createdAt,
  };
}

export type VCDBUser = {
  id: string;
  email: string;
  name: string;
  createdAt: Timestamp;
};
